$(function () {
  console.log('-fl4v10gs4p-');

  gsap.registerPlugin(ScrollTrigger);

  // larghezza schermo
  const larghezzaSchermo = window.innerWidth;

  //banner nascondi
  function toggleBannerVisibility() {
    const banner = document.querySelector('.collection .banner_saldi');
    console.log('isdbs');
    if (!banner) {
      return;
    }

    gsap.to(banner, {
      opacity: 0,
      pointerEvents: 'none',
      scrollTrigger: {
        trigger: 'body', // Puoi cambiare il trigger se necessario
        start: 'top+=' + 3100, // Inizia dopo 3100px di scorrimento
        end: 'top+=3101', //Un valore di end è necessario per il toggleActions
        toggleActions: 'play none reverse none', // play: aggiungi, reverse: rimuovi
        // markers: true,     // Per debug
        onEnter: () => {
          console.log('Banner nascosto');
        },
        onEnterBack: () => {
          console.log('Banner mostrato');
        },
      },
      duration: 0.1, //Durata irrilevante con toggleActions
      ease: 'power2.inOut',
    });
  }
  if (larghezzaSchermo < 1199) {
    toggleBannerVisibility();
  }

  // nascondi widget desktop Homepage
  if (larghezzaSchermo > 1199 && $('body.index').length) {
    let widgetWhite = $('.shopify-section[id*="__next_widget"]');

    ScrollTrigger.create({
      trigger: '.section_overlay_video',
      start: '-=3000',
      end: 'top',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          widgetWhite.removeClass('nascondi');
        } else {
          widgetWhite.addClass('nascondi');
        }
      },
    });
  }

  // nascondi btn shop mobile Homepage
  if (larghezzaSchermo < 1000 && $('body.index').length) {
    let shpBtnMenu = $('.shop_btn');
    let triggerEl = $(
      '#MainContent > .shopify-section:not(.shopify-section-group-footer-group, .shopify-section-group-header-group) .section_clean_video'
    )
      .parent()
      .last();

    ScrollTrigger.create({
      trigger: triggerEl,
      start: 'bottom bottom',
      end: '+=250% bottom',
      scroller: '#MainContent',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          shpBtnMenu.addClass('nascondi');
        } else {
          shpBtnMenu.removeClass('nascondi');
        }
      },
    });
  }

  // funzione overflow drag

  if (window.innerWidth > 1199) {
    const elementsWithDragScroll = document.querySelectorAll('.drag-scroll');

    elementsWithDragScroll.forEach(function (element) {
      let isDragging = false;
      let startX, scrollLeft;

      element.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;
      });

      element.addEventListener('mouseleave', function () {
        isDragging = false;
      });

      element.addEventListener('mouseup', function () {
        isDragging = false;
      });

      element.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - element.offsetLeft;
        const walk = (x - startX) * 1.2; // <- Aumenta o diminuisci la sensibilità del trascinamento
        element.scrollLeft = scrollLeft - walk;
      });
    });
  }
});
